import { Reveal, Eyebrow } from "@/lib/motion";

const FOUNDERS = [
  {
    name: "Lena Park",
    title: "CEO",
    prev: "ex-Flexport",
    body: "Ran ops at Flexport before this. She’s not guessing what slows a mid-market ops team down — she managed it.",
  },
  {
    name: "Arjun Mehta",
    title: "CTO",
    prev: "ex-UiPath",
    body: "Built enterprise automation at UiPath. RelayOps is what he’d have built instead, if “SMB” had ever been the brief.",
  },
  {
    name: "Marcus Hill",
    title: "Head of Sales",
    prev: "ex-ServiceTitan",
    body: "Sold workflow software at ServiceTitan. He knows exactly where those tools stop fitting a team like yours.",
  },
];

const initials = (n) => n.split(" ").map((p) => p[0]).join("");

export default function About() {
  return (
    <section id="about" className="relative bg-bg-primary/55 py-24 backdrop-blur-sm lg:py-32">
      <div className="container-max band-pad">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow testId="about-eyebrow">About</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Built by people who lived the problem, not just studied it.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.08}>
              <div
                data-testid={`founder-${i}`}
                className="flex h-full flex-col rounded-2xl border border-hairline bg-bg-surface p-8"
              >
                <div className="flex items-center gap-4">
                  <span className="grid h-14 w-14 place-items-center rounded-xl border border-signal/30 bg-signal/10 font-display text-lg font-semibold text-signal">
                    {initials(f.name)}
                  </span>
                  <div>
                    <div className="font-display text-lg font-semibold text-ink">
                      {f.name}
                    </div>
                    <div className="font-mono text-[11px] uppercase tracking-[0.15em] text-ink-muted">
                      {f.title} · {f.prev}
                    </div>
                  </div>
                </div>
                <p className="mt-6 leading-relaxed text-ink-muted">{f.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* closing line — system readout */}
        <Reveal delay={0.1}>
          <div className="mt-14 rounded-2xl border border-hairline bg-bg-surface/50 p-6">
            <p className="font-mono text-xs leading-relaxed text-ink-muted sm:text-sm">
              <span className="text-signal">$ relayops --under-the-hood</span>
              <br />
              AWS + Kubernetes infrastructure, OpenAI-powered agents — built to
              survive a technical review, not just a demo click-through.
              <span className="ml-1 inline-block h-3.5 w-2 translate-y-0.5 animate-blink bg-signal align-middle" />
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
